import React from 'react';
import { Link } from 'react-router-dom';
import { socialLinks } from '../data/mock';
import { MessageCircle, Send, Twitter } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-black border-t border-white/25 py-16">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/logo.png" alt="MatrixLaunch Logo" className="h-12 w-auto object-contain" />
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Decentralized launchpad connecting investors with vetted blockchain projects.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Platform</h4>
            <ul className="space-y-3">
              <li><Link to="/projects" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Projects</Link></li>
              <li><Link to="/about" className="text-white/60 hover:text-brand-primary transition-colors text-sm">About Us</Link></li>
              <li><Link to="/referral" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Referral Program</Link></li>
              <li><Link to="/learn" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Learn Crypto</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">Resources</h4>
            <ul className="space-y-3">
              <li><Link to="/contact" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Contact</Link></li>
              <li><Link to="/documentation" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Documentation</Link></li>
              <li><Link to="/whitepaper" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Whitepaper</Link></li>
              <li><Link to="/faq" className="text-white/60 hover:text-brand-primary transition-colors text-sm">FAQ</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-white font-semibold mb-4">Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/terms" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Terms of Service</Link></li>
              <li><Link to="/privacy" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Privacy Policy</Link></li>
              <li><Link to="/risk" className="text-white/60 hover:text-brand-primary transition-colors text-sm">Risk Disclosure</Link></li>
              <li><Link to="/kyc" className="text-white/60 hover:text-brand-primary transition-colors text-sm">KYC/AML Policy</Link></li>
            </ul>
          </div>
        </div>

        {/* Social Links & Copyright */}
        <div className="pt-8 border-t border-white/25 flex flex-col md:flex-row justify-between items-center gap-6">
          <p className="text-white/60 text-sm">
            © 2025 MatrixLaunch. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a 
              href={socialLinks.telegram} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 hover:text-brand-primary transition-colors"
            >
              <Send size={20} />
            </a>
            <a 
              href={socialLinks.discord} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 hover:text-brand-primary transition-colors"
            >
              <MessageCircle size={20} />
            </a>
            <a 
              href={socialLinks.twitter} 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-white/60 hover:text-brand-primary transition-colors"
            >
              <Twitter size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
